import React from 'react';
import { cn } from '@strivelabs/ui-core';
import type { AgentStep } from '../../types';

export const statusDotClass: Record<NonNullable<AgentStep['status']>, string> = {
  completed: 'border-emerald-500 bg-emerald-500',
  in_progress: 'border-amber-500 bg-amber-500',
  pending: 'border-muted-foreground/40 bg-muted-foreground/30',
  error: 'border-destructive bg-destructive',
};

export function StepStatusDot({ status }: { status?: AgentStep['status'] }) {
  const s = status ?? 'pending';
  return (
    <span
      className={cn(
        'mt-1.5 h-2 w-2 shrink-0 rounded-full border-2 border-background',
        statusDotClass[s],
      )}
      aria-hidden
    />
  );
}

/** Timeline node in the full-run dialog — solid white, no border. */
export function TimelineStepDot() {
  return (
    <span
      className="mt-3 size-2.5 shrink-0 rounded-full border-0 bg-white shadow-none"
      aria-hidden
    />
  );
}
